<form [formGroup]="watchThemeForm" autocomplete="off">
  <div class="d-flex justify-content-between flex-wrap gap-2">
    <div class="d-flex justify-content-start flex-wrap gap-2">
      <app-search
        [placeholder]="'Search theme'"
        (emitSearchKeyword)="receiveSearchKeyword($event)"
      ></app-search>
      <app-select
        [form]="watchThemeForm"
        [control]="watchThemeForm.controls['status']"
        [controlName]="'status'"
        [filter]="false"
        [submitted]="submitted"
        [data]="statusFilterOptions"
        [name]="'label'"
        [value]="'value'"
        [width]="'170px'"
        (emitSelectedValue)="receiveSelectedValue($event)"
        class="select-outline"
      ></app-select>
    </div>
    <div class="d-flex justify-content-end">
      <app-select
        [form]="watchThemeForm"
        [control]="watchThemeForm.controls['limit']"
        [controlName]="'limit'"
        [filter]="false"
        [submitted]="submitted"
        [data]="limits"
        [name]="'label'"
        [value]="'value'"
        [width]="defaultLimitSelectWidth"
        (emitSelectedValue)="receiveSelectedValue($event)"
        class="select-outline me-2"
      ></app-select>
      <button type="button" class="btn btn-primary" (click)="openAddEditModal()">
        <i-bs name="plus"></i-bs> Add Theme
      </button>
    </div>
  </div>

  <div
    class="mt-3 table-responsive scrollbar-primary thin watch-theme-table-wrap"
    #tableElement
    (scroll)="!loading && onScroll($event)"
  >
    <table class="table table-striped align-middle">
      <thead class="bg-gray-light text-gray-dark position-sticky top-0">
        <tr>
          <th></th>
          <th>Theme Name</th>
          <th>Design brief</th>
          <th>Status</th>
          <th>App Version</th>
          <th>Updated</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (theme of themes; track theme.id) {
          <tr>
            <td class="text-secondary">
              @if (theme.status === watchThemeStatus.PENDING_BUILD) {
                <i-bs name="clock-fill"></i-bs>
              } @else if (theme.status === watchThemeStatus.RETIRED) {
                <i-bs name="x-circle"></i-bs>
              } @else {
                <i-bs name="watch"></i-bs>
              }
            </td>
            <td>
              <div class="d-flex align-items-center gap-2">
                <span class="text-gray-dark">{{ theme.name }}</span>
                @if (theme.isDefault) {
                  <span class="watch-theme-default-chip">Default</span>
                }
              </div>
            </td>
            <td>
              @if (theme.designBrief?.fileName) {
                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="openBrief(theme, $event)"
                >
                  {{ theme.designBrief?.fileName }}
                </button>
                <div class="text-muted small">{{ theme.designBrief?.displayType }}</div>
              } @else {
                <span class="text-muted">None on file</span>
              }
            </td>
            <td>
              <span [class]="statusBadgeClass(theme)">{{ theme.status }}</span>
            </td>
            <td>
              @if (theme.watchAppVersion) {
                {{ theme.watchAppVersion }}
              } @else {
                <span class="text-muted">Not assigned</span>
              }
            </td>
            <td>
              <div class="d-flex flex-column" style="text-wrap: initial">
                <span>{{ (theme.updatedAt || theme.lastUpdated) | date : defaultDateFormat }}</span>
                <span>{{ theme.updatedBy?.name }}</span>
              </div>
            </td>
            <td class="text-nowrap">
              <div mdbDropdown class="dropdown">
                <a
                  role="button"
                  [id]="'watchThemeActions-' + theme.id"
                  aria-expanded="false"
                  mdbDropdownToggle
                >
                  <i-bs name="three-dots-vertical"></i-bs>
                </a>
                <ul
                  mdbDropdownMenu
                  class="dropdown-menu dropdown-menu-end"
                  [attr.aria-labelledby]="'watchThemeActions-' + theme.id"
                >
                  <li>
                    <a class="dropdown-item" role="button" (click)="openAddEditModal(theme)">
                      Edit
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" role="button" (click)="confirmDelete($event, theme)">
                      Delete
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (!loading && themes.length === 0) {
    <div class="pt-3 pb-4 mb-4 text-center">
      <i-bs name="journal-text" width="2rem" height="2rem"></i-bs>
      <p class="mt-2">{{ notFoundMessage }}</p>
    </div>
  }

  @if (loading && themes.length === 0) {
    <div class="mt-3">
      <app-loader [loader]="loading"></app-loader>
    </div>
  }
</form>
